/**
 * Facility check-in API
 * CCH Care
 *
 * Path: src/api/checkin.js
 *
 * Thin wrappers over /api/shifts/checkin.php. Mirrors api/shifts.js:
 * each function returns res.data (the flat { success, ... } payload).
 */
import client from './client';

const BASE = '/shifts/checkin.php';

/** Caller's current check-in (or null) + facilities they may enter. */
export async function getCheckinStatus() {
  const res = await client.get(`${BASE}?action=status`);
  return res.data;
}

/** Check the caller into a facility. */
export async function checkIn(facilityId) {
  const res = await client.post(`${BASE}?action=checkin`, { facility_id: facilityId });
  return res.data;
}

/** Close the caller's open check-in. Body {} keeps HostGator Mod_Security happy. */
export async function checkOut() {
  const res = await client.post(`${BASE}?action=checkout`, {});
  return res.data;
}

/** Who is currently present at a facility (optional admin/visibility use). */
export async function getPresent(facilityId) {
  const res = await client.get(`${BASE}?action=present&facility_id=${facilityId}`);
  return res.data;
}